import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import type { QuoteDraftLinePreview } from './types'

interface DeleteQuoteLineDialogProps {
  line: QuoteDraftLinePreview | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void | Promise<void>
}

export function DeleteQuoteLineDialog({
  line,
  open,
  onOpenChange,
  onConfirm,
}: DeleteQuoteLineDialogProps) {
  if (!line) return null

  const quantity = typeof line.quantity === 'number' ? line.quantity : null
  const unitPrice = typeof line.unitPrice === 'number' ? line.unitPrice : null
  const total = quantity != null && unitPrice != null ? (quantity * unitPrice).toFixed(2) : null

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>⚠️ Supprimer cette ligne ?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <div>
                <p className="font-medium text-foreground">{line.label}</p>
                {total != null ? (
                  <p className="text-sm text-muted-foreground mt-1">
                    {unitPrice?.toFixed(2)} € HT × {quantity}
                    {' = '}
                    <span className="font-medium">{total} € HT</span>
                  </p>
                ) : null}
              </div>
              <p className="text-destructive">Cette action est irréversible.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onOpenChange(false)}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Supprimer
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
